import licIC from "src/images/pages/cloud-native-platform/licensing.svg"
import ltsIC from "src/images/pages/cloud-native-platform/long-term-support.svg"
import openSourceIC from "src/images/pages/cloud-native-platform/open-source.svg"

import * as React from "react"
import {SmartLink} from "components/atoms/SmartLink";

export const moreAbouts = [
    {
        title: 'Licensing',
        background: '#FFFFFF',
            body: <p className={"p-2 color-gray"}>You can build containers yourself using the <SmartLink className={"underlined color-gray"} to={"/pages/downloads/"}>Stream free version of Alpaquita</SmartLink> with free <SmartLink className={"underlined color-gray"} to={"/pages/downloads/"}>Liberica JDK Lite</SmartLink>, or get our <SmartLink className={"underlined color-gray"} to={"/alpaquita-support/#pricing"}>support</SmartLink> with the full access to regular security updates, fixes, and support from our team.</p>,
        icon: licIC,
        gridColumn: '1/3'
    },
    {
        title: 'Long-term support',
        background: '#FFFFFF',
        body: <p className={"p-2 color-gray"}>Every LTS version of Alpaquita will be supported for <SmartLink className={"underlined color-gray"} to={"/support/"}>4 years minimum</SmartLink>, with 2 year confluence between two latest versions.</p>,
        icon: ltsIC,
        gridColumn: '3/5'
  },
    {
        title: 'Open source',
        background: '#FFFFFF',
        body: <p className={"p-2 color-gray"}>All clients get the access to the source code for all the products included in Alpaquita.</p>,
        icon: openSourceIC,
        gridColumn: '5/8',
    },

]
